import React from 'react'
import { Button } from '@mui/material';
import Card from '@mui/joy/Card';
import CardContent from '@mui/joy/CardContent';
import Typography from '@mui/joy/Typography';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import { useState } from 'react';
import CheckIcon from '@mui/icons-material/Check';
import PriorityHighIcon from '@mui/icons-material/PriorityHigh';
import ClearIcon from '@mui/icons-material/Clear';
import "../ContentSeo/TitleDivSeo.css"

function SizeOfPage(props) {



    const [open, setOpen] = useState(false);
    const handleClickOpen = () => {
        setOpen(true);
      };
    
      const handleClose = (e) => {
        setOpen(false);
      }



  return (
    <div id={`section-${props.index}`}>
      <div style={{marginTop:"10px"}} className='TitleDivSeo' onClick={handleClickOpen}>
      <div className="CARD" onClick={handleClickOpen}>
       <div
        style={{
          background: 'linear-gradient(to right, #ffcc00, #ff9900)', // Use your preferred background style
          padding: '10px',
          borderRadius:"5px",
          opacity:"0.6",
          color:"white"
        }}
      >
        <h3>حجم الصفحة</h3>
      </div>
       <Card orientation="horizontal" variant="outlined" sx={{ width: "100%",textAlign:"right"}}>
      <CardContent>
        <Typography fontWeight="md" textColor="success.plainColor">
          حجم الصفحة الخاصة بك هو {props.htmlSizeKB} KB الحجم التقريبي لفحات الانترنت العالمية هو 320KB
        </Typography>

</CardContent>
{ (props.htmlSizeKB / 1024) < 2  ?
  <CheckIcon style={{ color: "#27ae60", fontSize: "50px" }} /> : 
  <PriorityHighIcon style={{ color: "#f39c12",fontSize: "50px" }} /> }
    </Card>
    </div>
    <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogContent style={{direction:"rtl"}}>
          <DialogContentText id="alert-dialog-description" style={{color:"rgb(78, 181, 76)"}}>
          ثنان من الأسباب الرئيسية لزيادة حجم الصفحة هما الصور وملفات JavaScript.
يؤثر حجم الصفحة على سرعة موقع الويب الخاص بك ؛ حاول الحفاظ على حجم صفحتك أقل من 2 Mb.
نصيحة: استخدم الصور ذات الحجم الصغير وقم بتحسين تنزيلها باستخدام gzip.
          </DialogContentText>
        </DialogContent>
        <Button onClick={(e) => { e.stopPropagation(); handleClose(); }}>close</Button>
      </Dialog>
    </div>
    </div>
  )
}
export default SizeOfPage